import { Link } from "react-router-dom";
import { useMemo } from "react";
import { groupAccentColor } from "../../../utils/clientSessionUtils";
import s from "./clientApp.module.css";

function GroupCard({ group }) {
  const accent = groupAccentColor({ group });
  const groupStyle = accent ? { "--group-accent": accent } : undefined;

  return (
    <article className={s.profClubGroup} style={groupStyle}>
      <div className={s.profClubGroupAccent} aria-hidden />

      <div className={s.profClubGroupBody}>
        <header className={s.profClubGroupHead}>
          <div className={s.profClubGroupIcon} aria-hidden>
            <span className={s.profClubGroupDot} />
          </div>
          <div className={s.profClubGroupTitles}>
            <h3>{group.name}</h3>
            {group.direction || group.level ? (
              <p>{[group.direction, group.level].filter(Boolean).join(" · ")}</p>
            ) : null}
          </div>
        </header>

        <div className={s.profClubGroupMeta}>
          {group.trainers?.length > 0 ? (
            <div className={s.profClubGroupRow}>
              <span className={s.profClubGroupLbl}>Тренер</span>
              <span className={s.profClubGroupVal}>
                {group.trainers.map((t) => t.full_name).join(", ")}
              </span>
            </div>
          ) : null}

          {group.branch?.name ? (
            <div className={s.profClubGroupRow}>
              <span className={s.profClubGroupLbl}>Зал</span>
              <span className={s.profClubGroupVal}>{group.branch.name}</span>
            </div>
          ) : null}
        </div>

        {group.schedule?.length > 0 ? (
          <div className={s.profClubScheduleWrap}>
            <span className={s.profClubGroupLbl}>Расписание</span>
            <div className={s.profClubScheduleChips}>
              {group.schedule.map((slot) => (
                <span
                  key={`${slot.weekday}-${slot.start_time}`}
                  className={s.profClubScheduleChip}
                >
                  {slot.label}
                </span>
              ))}
            </div>
          </div>
        ) : null}

        <Link to="/app/calendar" className={s.profClubLink}>
          Календарь
          <span aria-hidden>→</span>
        </Link>
      </div>
    </article>
  );
}

export default function ClientClubGroups({ dash, schedule = [] }) {
  const dashGroups = dash?.groups || [];
  const groups = useMemo(() => {
    if (dashGroups.length) return dashGroups;
    const seen = new Map();
    for (const sess of schedule) {
      const g = sess.group;
      if (g?.id && !seen.has(g.id)) {
        seen.set(g.id, {
          id: g.id,
          name: g.name,
          direction: g.sport_direction || g.direction,
          trainers: sess.trainer
            ? [{ full_name: sess.trainer.user?.full_name || sess.trainer.full_name }]
            : [],
          branch: sess.branch || null,
          schedule: [],
        });
      }
    }
    return [...seen.values()];
  }, [dashGroups, schedule]);

  return (
    <div className={s.profClub}>
      <p className={s.profClubIntro}>
        Ваши группы и расписание регулярных занятий
      </p>

      <section className={s.profClubSection}>
        <h2 className={s.profClubSectionTitle}>Мои группы</h2>
        {groups.length === 0 ? (
          <p className={s.profMuted}>
            Вы пока не добавлены в группу. Администратор клуба подключит вас к
            занятиям.
          </p>
        ) : (
          <div className={s.profClubStack}>
            {groups.map((g) => (
              <GroupCard key={g.id} group={g} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
